<template>
	<div>
		<div class="center dialog-flex" style="margin: 0;">
			<div>
				<!-- <span class="dialog-tag">참여자 정보</span> -->
				<template
					v-for="(data, index) in emergencyActionList"
				>
					<table class="tb-crud-horizon popup-table" :key="index" style="margin-top: 30px;">
						<colgroup>
							<col width="140px" />
							<col width="300px" />
							<col width="140px" />
							<col width="auto" />
						</colgroup>
						<tbody>
							<tr style="border-top: 1px solid #191C26">
								<th>대상 데이터</th>
								<td class="font-red">
									{{ getRecordType(data.recordType) }}
								</td>
								<th>일시</th>
								<td>
									{{ data.emergencyDate.substring(0, 19) }}
								</td>
							</tr>
							<tr>
								<th>담당자</th>
								<td>
									{{ data.managerName }}
								</td>
							</tr>
							<tr>
								<th>내용</th>
								<td>
									{{ data.emergencyContents }}
								</td>
							</tr>
						</tbody>
					</table>
				</template>
				<div class="none-list" v-if="emergencyActionList.length == 0" style="margin-top:30px;"> 
					응급조치 내역이 없습니다.
				</div>
			</div>
		</div>
		<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
			<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click="doCancel()">
				닫기
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "ParticipantEmergency",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectEmergencyActionList();
	},
	data() {
		return {
			item: {},
			emergencyActionList: [],
		};
	},
	props: {
		collectData: {
			type: Object,
			required: true
		}
	},
	methods: {
		selectEmergencyActionList(){
			this.logger.debug(this, "selectEmergencyActionList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/participant/selectEmergencyActionList.do", this.collectData)
				.then((response) => {
					console.log(response);
					this.emergencyActionList = response.data.emergencyActionList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$parent.$refs.ParticipantDetail.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$parent.$refs.ParticipantDetail.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
</style>